import { render, staticRenderFns } from "./Betalock.vue?vue&type=template&id=d37559d0&scoped=true"
import script from "./Betalock.vue?vue&type=script&lang=js"
export * from "./Betalock.vue?vue&type=script&lang=js"
import style0 from "./Betalock.vue?vue&type=style&index=0&id=d37559d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37559d0",
  null
  
)

export default component.exports